// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuOTA0NDYgNy4wMDAxTDEzLjg0MTkgMC45NTI3NjZDMTQuMDg2OSAwLjcwMzY4NiAxNC4wNDIxIDAuMzM2MTkxIDEzLjc0MjUgMC4xMzIwMjdDMTMuNDQyOSAtMC4wNzA5Njk4IDEzLjAwMjYgLTAuMDM1Mzg3IDEyLjc1NzYgMC4yMTQ4Nkw3LjAwMDA2IDYuMDc5MDNMMS4yNDE4NiAwLjIxNDI3NkMwLjk5NjE1OSAtMC4wMzU5NzAzIDAuNTU1ODU5IC0wLjA3MTU1MzEgMC4yNTY5NTkgMC4xMzE0NDRDLTAuMDQyNjQxNSAwLjMzNjE5MSAtMC4wODY3NDE3IDAuNzAzMTAzIDAuMTU3NTU4IDAuOTUyMTgzTDYuMDk1NjYgNy4wMDAxTDAuMTU4MjU4IDEzLjA0NzRDLTAuMDg2NzQxNiAxMy4yOTY1IC0wLjA0MTk0MTYgMTMuNjY0IDAuMjU3NjU4IDEzLjg2ODJDMC4zODc4NTkgMTMuOTU2MyAwLjU0Mzk1OSAxNCAwLjcwMDA1OSAxNEMwLjkwMzA1OSAxNCAxLjEwMzk2IDEzLjkyNzEgMS4yNDI1NiAxMy43ODU5TDcuMDAwMDYgNy45MjExN0wxMi43NTgzIDEzLjc4NTNDMTIuODk2OSAxMy45MjY1IDEzLjA5NzggMTMuOTk5NCAxMy4zMDA4IDEzLjk5OTRDMTMuNDU2OSAxMy45OTk0IDEzLjYxMyAxMy45NTYzIDEzLjc0MzIgMTMuODY3NkMxNC4wNDI4IDEzLjY2MjggMTQuMDg2OSAxMy4yOTU5IDEzLjg0MjYgMTMuMDQ2OEw3LjAwMDA2IDcuMDAwMVoiIGZpbGw9IiNGMzdBNjUiLz4KPC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%2716%27 fill=%27none%27%3E%3Cpath d=%27M1.10187 16L0 14.8546L5.79626 8.00002L0 1.14542L1.10187 0L8 8.00002L1.10187 16Z%27 fill=%27%23FEFEFE%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%279%27 height=%2716%27 fill=%27none%27%3E%3Cpath d=%27M7.76122 16L8.89667 14.8546L3.07974 8.00002L8.89667 1.14542L7.76122 0L0.857117 8.00002L7.76122 16Z%27 fill=%27%23F37A65%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toastify__toast-body {
  max-height: 250px !important;
  overflow-y: auto !important;
}

.Toastify__toast-body::-webkit-scrollbar {
  display: none;
}

::-webkit-scrollbar {
  width: 7px;
  height: 5px;
}

::-webkit-scrollbar-thumb {
  background: #bdbdbd;
  cursor: pointer;
  border-radius: 2.5px;
}

::-webkit-scrollbar-track {
  background: #f8f8f8;
  border-radius: 2.5px;
}

.ck-editor__editable {
  /* min-height: 124px; */
  max-height: 250px;
}

.ck.ck-powered-by-balloon {
  display: none !important;
}

.ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
  border-color: #bdbdbd;
  /* min-height: 124px !important; */
}

.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: 0px 0px 4px 4px;
}

.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content {
  border-color: #bdbdbd;
  border-radius: 0px 0px 4px 4px;
}
.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable) {
  border-color: #bdbdbd;
  box-shadow: none;
  color: #184a61;
}

.ck .ck-editor__main {
  color: #184a61;
  font-family: Lato;
}

.ck-placeholder {
  color: rgba(0, 92, 135, 0.3) !important;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.ck .ck-placeholder:before,
.ck.ck-placeholder:before {
  color: #bdbdbd !important;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.ck-read-only {
  /* color: rgba(0, 122, 177, 0.3) !important; */
  color:  #BDBDBD;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
}

.global-title {
  color: rgb(0, 92, 135);
  font-family: lato;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
}

.global-label {
  font-size: 16px;
  color: #184A61;
  line-height: 21px;
  font-family: lato;
  font-weight: 400;
}

.global-sub-label {
  font-size: 16px;
  color: #184A61;
  line-height: 21px;
  font-family: lato;
  font-weight: 300;
}

.global-star {
  font-size: 18px;
  color: #f4aaa9;
}

.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled {
  background: #efefef;
}

/* === DRIVER.JS CUSTOM STYLES === */

.driver-popover.figma-tour-popover {
  display: flex !important;
  flex-direction: column !important;
  width: 406px !important;
  min-width: auto !important;
  max-width: none !important;
  min-height: 176px !important;
  padding: 16px 24px !important;
  align-items: stretch !important;
  background: #f8f8f8 !important;
  border-radius: 12px;
  gap: 16px !important;
  font-family: "Lato", sans-serif;
  border: 1px solid #e5e7eb;
  box-sizing: border-box !important;
}

/* Title */
.figma-tour-popover .driver-popover-title {
  font-size: 18px;
  font-weight: 700;
  color: #184a61;
  font-family: "Lato";
  font-style: normal;
  line-height: 24px;
}

.figma-tour-popover .driver-popover-close-btn {
  position: absolute;
  top: 20px;
  right: 24px;
  width: 14px;
  height: 14px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Your SVG Data URI */
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  background-color: transparent;
  font-size: 0 !important;
  color: transparent !important;
  text-indent: -9999px !important;
  overflow: hidden !important;
  line-height: 0 !important;
  text-shadow: none !important;
  appearance: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  border: none;
  padding: 0;
  cursor: pointer;
  outline: none;
  opacity: 1;
}

/* Description */
.figma-tour-popover .driver-popover-description {
  /* margin-bottom: 12px; */
  color: #184a61;
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

/* Progress text */
.figma-tour-popover .driver-popover-progress-text {
  font-size: 18px;
  color: #184a61;
  font-style: normal;
  font-family: "Lato";
  font-weight: 400px;
  line-height: 24px;
}

/* Footer (button layout) */
.figma-tour-popover .driver-popover-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  margin-top: 16px;
}

/* Button container */
.figma-tour-popover .driver-popover-navigation-btns {
  display: flex;
  gap: 10px;
}

.figma-tour-popover .driver-popover-prev-btn {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 12px 16px;
  border: none;
  border-radius: 4px;
  font-family: "Lato";
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
  background-color: white;
  color: #184a61;
  border: 1px solid #f37a65;
}
.figma-tour-popover .driver-popover-next-btn {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 12px 16px;
  border: none;
  border-radius: 4px;
  background: #f37a65;
  color: #fefefe;
  font-family: Lato !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 400 !important;
  line-height: 20px;
  cursor: pointer;
  text-shadow: none !important;
}
.figma-tour-popover .driver-popover-next-btn::after {
  content: "";
  display: inline-block !important;
  width: 8px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: contain;
  margin-left: 8px;
  vertical-align: middle;
  text-shadow: none !important;
}

.figma-tour-popover .driver-popover-next-btn::after {
  content: "";
  display: inline-block;
  width: 8px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: contain;
  flex-shrink: 0;
}

.figma-tour-popover .driver-popover-prev-btn::before {
  content: "";

  width: 9px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: contain;
  margin-right: 8px;
  vertical-align: middle;
}
.figma-tour-popover .driver-popover-next-btn:hover {
  background: #f37a65;
  color: #fefefe;
}

/* .driver-popover .driver-popover-next-btn .icon-arrow,
.driver-popover .driver-popover-prev-btn .icon-arrow {
  display: inline-block;
  vertical-align: middle;
} */
.figma-tour-popover .icon-arrow {
  display: inline-block;
  width: auto;
  height: 16px;
  vertical-align: middle;
  margin-left: 4px; /* Optional spacing tweak */
}
/* Disabled buttons */
.figma-tour-popover .driver-popover-btn-disabled {
  background-color: #f0f0f0 !important;
  color: #999 !important;
  border: none !important;
  cursor: not-allowed !important;
}
.imgUploder .middle-section {
    padding-left: 15px;
}
.imgUploder .innerDivImageContainer img {
    height: 182px;
    width: 182px;
    object-fit: cover;
    border-radius: 6px;
}
.check-input {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  width: 18px;
  height: 18px;
  border: 1px solid #7C7C7C;
  background: transparent;
  cursor: pointer;
  position: relative;
  border-radius: 4px;
}
.check-input:checked {
  background: transparent;
  border-color: #DA6C74;
  border-radius: 4px;
}
.check-input:checked::after {
  content: "";
    position: absolute;
    left: 6px;
    top: 3px;
    width: 5px;
    height: 10px;
    border: solid #DA6C74;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

.check-input:focus {
  outline: none;
  box-shadow: none;
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
  -webkit-text-fill-color: #184A61 !important;
}

.custom-popover {
  max-width: 360px !important;
  width: max-content !important;
  color: #184A61 !important;
  border-radius: 6px !important;
  border: 0.75px solid #E6E6E6 !important;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08) !important;
  background: #FFFFFF !important;
}

.custom-popover .popover-body {
  padding: 4px 16px !important;
  font-family: 'Lato' !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #184A61 !important;
  text-align: left; 
}

.custom-popover.bs-popover-bottom .popover-arrow::before {
  border-bottom-color: #E6E6E6 !important;
}

.custom-popover.bs-popover-bottom .popover-arrow::after {
  border-bottom-color: #FFFFFF !important;
}

.rdtPicker td, .rdtPicker th {
    color: #184A61;
}`, "",{"version":3,"sources":["webpack://./src/css/app.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;EAC9C,eAAe;AACjB,iBAAiB;AACjB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;AACjB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oCAAoC;;AAEpC;EACE,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,+BAA+B;EAC/B,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA,UAAU;AACV;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yDAA+jC,EAAE,sBAAsB;EACvlC,4BAA4B;EAC5B,kCAAkC;EAClC,wBAAwB;EACxB,6BAA6B;EAC7B,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,gCAAgC;EAChC,UAAU;EACV,YAAY;EACZ,yDAAoP;EACpP,4BAA4B;EAC5B,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,yDAAoP;EACpP,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,WAAW;;EAEX,UAAU;EACV,YAAY;EACZ,yDAAuQ;EACvQ,4BAA4B;EAC5B,wBAAwB;EACxB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;GAIG;AACH;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gBAAgB,EAAE,2BAA2B;AAC/C;AACA,qBAAqB;AACrB;EACE,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;AAChC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;;EAErB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,WAAW;IACT,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,sDAAsD;EACtD,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,6BAA6B;EAC7B,uCAAuC;EACvC,uDAAuD;EACvD,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".Toastify__toast-body {\n  max-height: 250px !important;\n  overflow-y: auto !important;\n}\n\n.Toastify__toast-body::-webkit-scrollbar {\n  display: none;\n}\n\n::-webkit-scrollbar {\n  width: 7px;\n  height: 5px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #bdbdbd;\n  cursor: pointer;\n  border-radius: 2.5px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f8f8f8;\n  border-radius: 2.5px;\n}\n\n.ck-editor__editable {\n  /* min-height: 124px; */\n  max-height: 250px;\n}\n\n.ck.ck-powered-by-balloon {\n  display: none !important;\n}\n\n.ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {\n  border-color: #bdbdbd;\n  /* min-height: 124px !important; */\n}\n\n.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,\n.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {\n  border-radius: 0px 0px 4px 4px;\n}\n\n.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content {\n  border-color: #bdbdbd;\n  border-radius: 0px 0px 4px 4px;\n}\n.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable) {\n  border-color: #bdbdbd;\n  box-shadow: none;\n  color: #184a61;\n}\n\n.ck .ck-editor__main {\n  color: #184a61;\n  font-family: Lato;\n}\n\n.ck-placeholder {\n  color: rgba(0, 92, 135, 0.3) !important;\n  font-family: Lato;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.ck .ck-placeholder:before,\n.ck.ck-placeholder:before {\n  color: #bdbdbd !important;\n  font-family: Lato;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.ck-read-only {\n  /* color: rgba(0, 122, 177, 0.3) !important; */\n  color:  #BDBDBD;\nfont-family: Lato;\nfont-size: 16px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 20px; \n}\n\n.global-title {\n  color: rgb(0, 92, 135);\n  font-family: lato;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.global-label {\n  font-size: 16px;\n  color: #184A61;\n  line-height: 21px;\n  font-family: lato;\n  font-weight: 400;\n}\n\n.global-sub-label {\n  font-size: 16px;\n  color: #184A61;\n  line-height: 21px;\n  font-family: lato;\n  font-weight: 300;\n}\n\n.global-star {\n  font-size: 18px;\n  color: #f4aaa9;\n}\n\n.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled {\n  background: #efefef;\n}\n\n/* === DRIVER.JS CUSTOM STYLES === */\n\n.driver-popover.figma-tour-popover {\n  display: flex !important;\n  flex-direction: column !important;\n  width: 406px !important;\n  min-width: auto !important;\n  max-width: none !important;\n  min-height: 176px !important;\n  padding: 16px 24px !important;\n  align-items: stretch !important;\n  background: #f8f8f8 !important;\n  border-radius: 12px;\n  gap: 16px !important;\n  font-family: \"Lato\", sans-serif;\n  border: 1px solid #e5e7eb;\n  box-sizing: border-box !important;\n}\n\n/* Title */\n.figma-tour-popover .driver-popover-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #184a61;\n  font-family: \"Lato\";\n  font-style: normal;\n  line-height: 24px;\n}\n\n.figma-tour-popover .driver-popover-close-btn {\n  position: absolute;\n  top: 20px;\n  right: 24px;\n  width: 14px;\n  height: 14px;\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuOTA0NDYgNy4wMDAxTDEzLjg0MTkgMC45NTI3NjZDMTQuMDg2OSAwLjcwMzY4NiAxNC4wNDIxIDAuMzM2MTkxIDEzLjc0MjUgMC4xMzIwMjdDMTMuNDQyOSAtMC4wNzA5Njk4IDEzLjAwMjYgLTAuMDM1Mzg3IDEyLjc1NzYgMC4yMTQ4Nkw3LjAwMDA2IDYuMDc5MDNMMS4yNDE4NiAwLjIxNDI3NkMwLjk5NjE1OSAtMC4wMzU5NzAzIDAuNTU1ODU5IC0wLjA3MTU1MzEgMC4yNTY5NTkgMC4xMzE0NDRDLTAuMDQyNjQxNSAwLjMzNjE5MSAtMC4wODY3NDE3IDAuNzAzMTAzIDAuMTU3NTU4IDAuOTUyMTgzTDYuMDk1NjYgNy4wMDAxTDAuMTU4MjU4IDEzLjA0NzRDLTAuMDg2NzQxNiAxMy4yOTY1IC0wLjA0MTk0MTYgMTMuNjY0IDAuMjU3NjU4IDEzLjg2ODJDMC4zODc4NTkgMTMuOTU2MyAwLjU0Mzk1OSAxNCAwLjcwMDA1OSAxNEMwLjkwMzA1OSAxNCAxLjEwMzk2IDEzLjkyNzEgMS4yNDI1NiAxMy43ODU5TDcuMDAwMDYgNy45MjExN0wxMi43NTgzIDEzLjc4NTNDMTIuODk2OSAxMy45MjY1IDEzLjA5NzggMTMuOTk5NCAxMy4zMDA4IDEzLjk5OTRDMTMuNDU2OSAxMy45OTk0IDEzLjYxMyAxMy45NTYzIDEzLjc0MzIgMTMuODY3NkMxNC4wNDI4IDEzLjY2MjggMTQuMDg2OSAxMy4yOTU5IDEzLjg0MjYgMTMuMDQ2OEw3LjAwMDA2IDcuMDAwMVoiIGZpbGw9IiNGMzdBNjUiLz4KPC9zdmc+\"); /* Your SVG Data URI */\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: contain;\n  background-color: transparent;\n  font-size: 0 !important;\n  color: transparent !important;\n  text-indent: -9999px !important;\n  overflow: hidden !important;\n  line-height: 0 !important;\n  text-shadow: none !important;\n  appearance: none !important;\n  -webkit-appearance: none !important;\n  -moz-appearance: none !important;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  outline: none;\n  opacity: 1;\n}\n\n/* Description */\n.figma-tour-popover .driver-popover-description {\n  /* margin-bottom: 12px; */\n  color: #184a61;\n  font-family: Lato;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n/* Progress text */\n.figma-tour-popover .driver-popover-progress-text {\n  font-size: 18px;\n  color: #184a61;\n  font-style: normal;\n  font-family: \"Lato\";\n  font-weight: 400px;\n  line-height: 24px;\n}\n\n/* Footer (button layout) */\n.figma-tour-popover .driver-popover-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-content: center;\n  margin-top: 16px;\n}\n\n/* Button container */\n.figma-tour-popover .driver-popover-navigation-btns {\n  display: flex;\n  gap: 10px;\n}\n\n.figma-tour-popover .driver-popover-prev-btn {\n  display: inline-flex !important;\n  align-items: center;\n  gap: 8px;\n  height: 40px;\n  padding: 12px 16px;\n  border: none;\n  border-radius: 4px;\n  font-family: \"Lato\";\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 20px;\n  cursor: pointer;\n  background-color: white;\n  color: #184a61;\n  border: 1px solid #f37a65;\n}\n.figma-tour-popover .driver-popover-next-btn {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 40px;\n  padding: 12px 16px;\n  border: none;\n  border-radius: 4px;\n  background: #f37a65;\n  color: #fefefe;\n  font-family: Lato !important;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400 !important;\n  line-height: 20px;\n  cursor: pointer;\n  text-shadow: none !important;\n}\n.figma-tour-popover .driver-popover-next-btn::after {\n  content: \"\";\n  display: inline-block !important;\n  width: 8px;\n  height: 16px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='16' fill='none'%3E%3Cpath d='M1.10187 16L0 14.8546L5.79626 8.00002L0 1.14542L1.10187 0L8 8.00002L1.10187 16Z' fill='%23FEFEFE'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  margin-left: 8px;\n  vertical-align: middle;\n  text-shadow: none !important;\n}\n\n.figma-tour-popover .driver-popover-next-btn::after {\n  content: \"\";\n  display: inline-block;\n  width: 8px;\n  height: 16px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='16' fill='none'%3E%3Cpath d='M1.10187 16L0 14.8546L5.79626 8.00002L0 1.14542L1.10187 0L8 8.00002L1.10187 16Z' fill='%23FEFEFE'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  flex-shrink: 0;\n}\n\n.figma-tour-popover .driver-popover-prev-btn::before {\n  content: \"\";\n\n  width: 9px;\n  height: 16px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='16' fill='none'%3E%3Cpath d='M7.76122 16L8.89667 14.8546L3.07974 8.00002L8.89667 1.14542L7.76122 0L0.857117 8.00002L7.76122 16Z' fill='%23F37A65'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  margin-right: 8px;\n  vertical-align: middle;\n}\n.figma-tour-popover .driver-popover-next-btn:hover {\n  background: #f37a65;\n  color: #fefefe;\n}\n\n/* .driver-popover .driver-popover-next-btn .icon-arrow,\n.driver-popover .driver-popover-prev-btn .icon-arrow {\n  display: inline-block;\n  vertical-align: middle;\n} */\n.figma-tour-popover .icon-arrow {\n  display: inline-block;\n  width: auto;\n  height: 16px;\n  vertical-align: middle;\n  margin-left: 4px; /* Optional spacing tweak */\n}\n/* Disabled buttons */\n.figma-tour-popover .driver-popover-btn-disabled {\n  background-color: #f0f0f0 !important;\n  color: #999 !important;\n  border: none !important;\n  cursor: not-allowed !important;\n}\n.imgUploder .middle-section {\n    padding-left: 15px;\n}\n.imgUploder .innerDivImageContainer img {\n    height: 182px;\n    width: 182px;\n    object-fit: cover;\n    border-radius: 6px;\n}\n.check-input {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n\n  width: 18px;\n  height: 18px;\n  border: 1px solid #7C7C7C;\n  background: transparent;\n  cursor: pointer;\n  position: relative;\n  border-radius: 4px;\n}\n.check-input:checked {\n  background: transparent;\n  border-color: #DA6C74;\n  border-radius: 4px;\n}\n.check-input:checked::after {\n  content: \"\";\n    position: absolute;\n    left: 6px;\n    top: 3px;\n    width: 5px;\n    height: 10px;\n    border: solid #DA6C74;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n}\n\n.check-input:focus {\n  outline: none;\n  box-shadow: none;\n}\ninput:-webkit-autofill {\n  -webkit-box-shadow: 0 0 0 1000px #fff inset !important;\n  -webkit-text-fill-color: #184A61 !important;\n}\n\n.custom-popover {\n  max-width: 360px !important;\n  width: max-content !important;\n  color: #184A61 !important;\n  border-radius: 6px !important;\n  border: 0.75px solid #E6E6E6 !important;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08) !important;\n  background: #FFFFFF !important;\n}\n\n.custom-popover .popover-body {\n  padding: 4px 16px !important;\n  font-family: 'Lato' !important;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #184A61 !important;\n  text-align: left; \n}\n\n.custom-popover.bs-popover-bottom .popover-arrow::before {\n  border-bottom-color: #E6E6E6 !important;\n}\n\n.custom-popover.bs-popover-bottom .popover-arrow::after {\n  border-bottom-color: #FFFFFF !important;\n}\n\n.rdtPicker td, .rdtPicker th {\n    color: #184A61;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
